import React, { useState, useEffect } from 'react';
import { collection, query, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export default function DocumentCloudModal({ serverId, serviceUserId, onClose }) {
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchDocuments = async () => {
            setLoading(true);
            try {
                const ref = collection(db, 'servers', serverId, 'serviceUsers', serviceUserId, 'documents');
                const q = query(ref); 
                const snap = await getDocs(q);
                
                const loaded = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                
                loaded.sort((a, b) => {
                    const getMs = (val) => {
                        if (!val) return 0;
                        if (typeof val.toDate === 'function') return val.toDate().getTime();
                        if (val.seconds) return val.seconds * 1000;
                        return new Date(val).getTime() || 0;
                    };
                    const dateA = getMs(a.date || a.createdAt || a.timestamp);
                    const dateB = getMs(b.date || b.createdAt || b.timestamp);
                    return dateB - dateA;
                });
                
                setDocuments(loaded);
            } catch (err) {
                console.error("Error fetching documents:", err);
                setError("Failed to load documents.");
            } finally {
                setLoading(false);
            }
        };

        if (serverId && serviceUserId) {
            fetchDocuments();
        }
    }, [serverId, serviceUserId]);

    return (
        <div style={styles.modalOverlay} onClick={onClose}>
            <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
                <div style={styles.modalHeader}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '20px', color: '#111827' }}>Document Cloud</h2>
                        <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: '14px' }}>File attachments and scanned records</p>
                    </div>
                    <button onClick={onClose} style={styles.closeBtn}>×</button>
                </div>

                <div style={styles.scrollArea}>
                    {loading ? (
                        <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>Loading documents...</div>
                    ) : error ? (
                        <div style={{ padding: '40px', textAlign: 'center', color: '#ef4444' }}>{error}</div>
                    ) : documents.length === 0 ? (
                        <div style={styles.emptyState}>
                            <div style={{ fontSize: '48px', marginBottom: '16px' }}>🗂️</div>
                            <h3 style={{ margin: '0 0 8px 0', color: '#374151' }}>No Documents</h3>
                            <p style={{ margin: 0, color: '#6b7280' }}>No files have been uploaded yet.</p>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {documents.map((doc, index) => (
                                <div key={doc.id || index} style={styles.recordCard}>
                                    <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                        <div style={{ fontSize: '24px', marginRight: '16px' }}>📄</div>
                                        <div>
                                            <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#111827', marginBottom: '4px' }}>{doc.name || 'Untitled Document'}</div>
                                            <div style={{ fontSize: '13px', color: '#6b7280' }}>
                                                Added: {doc.date || doc.createdAt ? new Date(doc.date?.seconds ? doc.date.seconds * 1000 : doc.date || doc.createdAt?.seconds * 1000 || doc.createdAt).toLocaleDateString() : 'Unknown date'}
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginLeft: '16px' }}>
                                        {doc.url ? (
                                            <a href={doc.url} target="_blank" rel="noopener noreferrer" style={styles.downloadBtn}>
                                                View File
                                            </a>
                                        ) : (
                                            <span style={{ color: '#9ca3af', fontSize: '13px' }}>No link available</span>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

const styles = {
    modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
    modalContent: { backgroundColor: 'white', borderRadius: '12px', width: '90%', maxWidth: '700px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' },
    modalHeader: { padding: '24px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' },
    closeBtn: { background: 'none', border: 'none', fontSize: '24px', color: '#9ca3af', cursor: 'pointer', lineHeight: 1 },
    scrollArea: { padding: '24px', overflowY: 'auto', flex: 1, backgroundColor: '#f9fafb' },
    emptyState: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 0', textAlign: 'center', backgroundColor: 'white', borderRadius: '8px', border: '1px dashed #d1d5db' },
    recordCard: { display: 'flex', alignItems: 'center', backgroundColor: 'white', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '16px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' },
    downloadBtn: { display: 'inline-block', padding: '8px 16px', backgroundColor: '#f3f4f6', color: '#374151', textDecoration: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: 'bold', border: '1px solid #d1d5db' }
};
